var n={NUMBER_10:10,NUMBER_20:20,NUMBER_50:50};function r(n){return t(n)}function t(n,r){return n}function u(n){return n}export{n as PageSize,r as PageSizeFromJSON,t as PageSizeFromJSONTyped,u as PageSizeToJSON};
